import { h } from "@stencil/core";
import { navContentStore } from "@phn/state/nav-content-store";
import { NavigationMode, NavigationTheme } from "@phn/utility/constants";
import { finderStateStore } from "@phn/state/finder-state-store";
import {
  ContextualIconProps,
  ContextualIconResponse,
} from "@phn/utility/constants/app";
import { getRightTheme } from "@phn/utility/helper";
import { pushLevel0IconClickEvent } from "@phn/services/analytics/send-data-layer-events-service";
import { handleFilledIcon } from "@phn/utility/helper/shop-helper";
import { BadgeCount } from "./badge-count";
import {
  pureButtonSkeleton,
  pureButtonSkeletonDark,
} from "../../utility/skeleton";

export default function iccLevel0Icons({
  mode,
  theme,
  isNavigationLoaded,
}: ContextualIconProps): ContextualIconResponse {
  const { myPorsche, level0, vehiclePurchase } = navContentStore.state;
  const { savedVehiclesCount } = finderStateStore.state;

  const finderSavedVehiclesLink = myPorsche?.savedVehicles?.link ?? "";
  const finderSavedSearchesVehiclePurchaseLink =
    vehiclePurchase?.savedVehicles?.link ?? "";
  const [link, elementId] = myPorsche
    ? [finderSavedVehiclesLink, "mainmenu.myporsche.savedvehicles"]
    : [
        finderSavedSearchesVehiclePurchaseLink,
        "mainmenu.vehiclepurchase.savedvehicles",
      ];

  const getAriaLabelForFinder = function (): string {
    return `My saved vehicles, ${savedVehiclesCount} vehicles saved`;
  };

  return {
    leftIcons: null,
    rightIcons: (
      <div class="icon tooltip">
        <phn-p-link-pure
          target={"_self"}
          hide-label="true"
          icon="none"
          theme={getRightTheme(theme, mode)}
          style={isNavigationLoaded ? {} : { display: "none" }}
          class="saved-items"
          data-test-id="saved-vehicles-link"
          onClick={() => {
            pushLevel0IconClickEvent(link, elementId, "Saved Vehicles");
          }}
        >
          <a href={link} aria-label={getAriaLabelForFinder()}>
            <div class="icon-flex">
              <BadgeCount
                numberOfItems={savedVehiclesCount}
                theme={theme}
                mode={mode}
              />
              <phn-p-icon
                theme={getRightTheme(theme, mode)}
                name={handleFilledIcon("bookmark", savedVehiclesCount)}
                data-test-id="saved-vehicles-link-icon"
              />
            </div>
          </a>
        </phn-p-link-pure>
        <span
          class="tooltip-text finder_icon"
          data-test-id="saved-vehicles-tooltip-text"
        >
          {level0["mainmenu.level0.finder.savedvehicles"]}
        </span>
        {!isNavigationLoaded
          ? mode === NavigationMode.hero && theme === NavigationTheme.dark
            ? pureButtonSkeletonDark()
            : pureButtonSkeleton()
          : null}
      </div>
    ),
  };
}
